import React, { useState, FormEvent, useContext, Fragment, useEffect } from "react";
import { Segment, Form, Button, Dropdown, Input, Image, Grid } from "semantic-ui-react";
import { IAsset as IAsset } from "../../../app/models/asset";
import { v4 as uuid } from "uuid";
import AssetStore from "../../../app/stores/assetStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";
import AssetPhotoDropzone from "./AssetPhotoDropzone";

const AssetCreateForm: React.FC<RouteComponentProps> = ({
  match,
  history,
}) => {
  const assetStore = useContext(AssetStore);
  const { createAsset, generate, loadEmployees, employeesByName, submitting } = assetStore;

  useEffect(() => {
    loadEmployees();
  }, []);
  
  const [files, setFiles] = useState<any[]>([]);
  const [asset, setAsset] = useState<IAsset>({
    id: "",
    createdAt: "",
    updatedAt: "",
    code: "",
    assetName: "",
    type: "",
    model: "",
    price: 0,
    purchaseDate: "",
    status: "",
    life: "",
    inspectionDate: "",
    inspectionFrequency: 0,
    serviceDate: "",
    regoDate: "",
    insuranceDate: "",
    photoUrl: [""],
    barcodeFileId: "",
    barcodeUrl: "",
    remark: "",
    keep: [{
      id: "",
      createdAt: "",
      updatedAt: "",
      assetId: "",
      keeper: "",
      keepDate: "",
      remark: "",
    }],
  });

  const handleSubmit = () => {
    createAsset(files, asset).then(() =>
      history.push(`/dailymanagement/asset`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setAsset({ ...asset, [name]: value });
  };

  const employeeOptions = employeesByName.map(function (employee) {
    var option = { "key": employee.id, "text": employee.name, "value": employee.name }
    return option;
  }
  );

  employeeOptions.push({key: 'Office', text: 'Office', value: 'Office'})

  const status = [
    { key: "In Stock", text: "In Stock", value: "In Stock" },
    { key: "Lent Out", text: "Lent Out", value: "Lent Out" }
  ];

  const type = [{ key: "Equipment", text: "Equipment", value: "Equipment" },
  { key: "Tool", text: "Tool", value: "Tool" },
  { key: "Vehicle", text: "Vehicle", value: "Vehicle" }];

  return (
    <Segment clearing>
      <Form >
        <Form.Group >
          <Form.Input
            label="Asset Code"
            onChange={handleInputChange}
            name="code"
            required
            width="6"
            placeholder="Asset Code"
            value={asset.code}
          />
          <Form.Button
            onClick={() => generate().then((code) =>
              setAsset({ ...asset, ["code"]: code }))}
            width="2"
            floated="left"
            content="Generate"
            style={{ marginTop: '1.7em' }}
          />
          <Form.Select
            label="Type"
            required
            onChange={(e, { name, value }) =>
              setAsset({ ...asset, [name]: value })
            }
            width="8"
            name="type"
            placeholder="Type"
            options={type}
            value={asset.type}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Asset Name"
            onChange={handleInputChange}
            required
            name="assetName"
            placeholder="Asset Name"
            value={asset.assetName}
          />
          <Form.Input
            label="Model"
            onChange={handleInputChange}
            name="model"
            placeholder="Model"
            value={asset.model}
          />
          <Form.Select
            label="Status"
            required
            onChange={(e, { name, value }) =>
              setAsset({ ...asset, [name]: value })
            }
            options={status}
            name="status"
            placeholder="Status"
            value={asset.status}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Price"
            onChange={handleInputChange}
            name="price"
            type="number"
            placeholder="Price"
            value={asset.price}
          />
          <Form.Input
            label="Purchase Date"
            onChange={handleInputChange}
            name="purchaseDate"
            type="date"
            placeholder="Purchase Date"
            value={asset.purchaseDate}
          />
          <Form.Input
            label="Service Life"
            onChange={handleInputChange}
            name="life"
            placeholder="Service Life"
            value={asset.life}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Select
            label="Keeper"
            required
            search
            onChange={(e, { name, value }) => {
              let newArray = [...asset.keep];
              newArray[0].keeper = value!.toString();
              setAsset({
                ...asset, keep: newArray
              })
            }
            }
            name="keeper"
            placeholder="Keeper"
            options={employeeOptions}
            value={asset.keep[0].keeper}
          />
          <Form.Input
            label="Keep Date"
            required
            onChange={(e, { name, value }) => {
              let newArray = [...asset.keep];
              newArray[0].keepDate = value;
              setAsset({
                ...asset, keep: newArray
              })
            }
            }
            name="keepDate"
            type="date"
            placeholder="Keep Date"
            value={asset.keep[0].keepDate}
          />
        </Form.Group>
         {(asset.type === 'Tool') && 
         <Form.Group widths="equal">
         <Form.Input
            label="Next Inspection Date"
            onChange={handleInputChange}
            name="inspectionDate"
            type="date"
            placeholder="Inspection Date"
            value={asset.inspectionDate}
         /> 
         <Form.Input
            label="Inspection Frequency (number of months, e.g. input 12 for 12 months)"
            onChange={handleInputChange}
            name="inspectionFrequency"
            type="number"
            placeholder="Inspection Frequency"
            value={asset.inspectionFrequency}
         />
         </Form.Group>}
         {(asset.type === 'Vehicle') &&  <Form.Input
            label="Next Service Date"
            onChange={handleInputChange}
            name="serviceDate"
            type="date"
            width="8"
            placeholder="Service Date"
            value={asset.serviceDate}
          /> }

        <Form.Group widths="equal">
        {(asset.type === 'Vehicle') &&  <Form.Input
            label="Next Rego Date"
            onChange={handleInputChange}
            name="regoDate"
            type="date"
            placeholder="Rego Date"
            value={asset.regoDate}
          /> }
        {(asset.type === 'Vehicle') &&   <Form.Input
            label="Next Insurance Date"
            onChange={handleInputChange}
            name="insuranceDate"
            type="date"
            placeholder="Insurance Date"
            value={asset.insuranceDate}
          /> }
        </Form.Group>
        <Form.TextArea
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          rows={2}
          placeholder="Remark"
          value={asset.remark}
        />
        <div>
          <Button
            color="grey"
            content={<AssetPhotoDropzone setFiles={setFiles} />}
          />
          {files.length > 0 && (
            <Fragment>
              <Grid>
              {files.map(file => ( <Grid.Column width='4'>
              <Image
                src={file.preview}
              />
              </Grid.Column>))}
              </Grid>
              <Button
                icon='close'
                size='small'
                color='red'
                onClick={() => setFiles([])}
              />
            </Fragment>
          )}
        </div>
        <Button
          loading={submitting}
          floated="right"
          positive
          onClick={handleSubmit}
          content="Submit"
        />
        <Button
          onClick={() => history.push("/dailymanagement/asset")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(AssetCreateForm);
